import type {
  ConsumptionShares,
  DateRangeConsumptionShare
} from "../../../utils/backend-types";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { luxonDateTimeToBackendDateOrDateTimeOrNull } from "../../../utils/dates/luxonDateTimeToBackendDateOrDateTimeOrNull";

export function getNewConsumptionSharesOnAdd(
  currentShares: ConsumptionShares | undefined,
  newShare: DateRangeConsumptionShare
) {
  const newShares = { ...currentShares };
  if (!currentShares || !newShare || !newShares.dateRangeConsumptionShares) {
    return currentShares;
  }

  const newLastDateWithDayBefore = newShare.firstDate
    ? luxonDateTimeToBackendDateOrDateTimeOrNull(
        backendDateOrDateTimeToLuxonDateTime(newShare.firstDate).minus({
          days: 1
        })
      )
    : null;

  let newDateRangeConsumptionShares:
    Array<DateRangeConsumptionShare> | undefined = [
    ...getSortedDateArrayFromDateRangeConsumptionShares(
      newShares.dateRangeConsumptionShares
    )
  ];

  putNewShareIntoDateRangeConsumptionShares(
    newDateRangeConsumptionShares,
    newShare
  );
  newDateRangeConsumptionShares = newShares.dateRangeConsumptionShares?.map(
    (share) => {
      if (!share.lastDate) {
        return {
          ...share,
          lastDate: newLastDateWithDayBefore
        };
      }
      return share;
    }
  );
  if (!newDateRangeConsumptionShares) {
    return currentShares;
  }

  newDateRangeConsumptionShares.push(newShare);
  newShares.dateRangeConsumptionShares = newDateRangeConsumptionShares;
  return newShares;
}

function getSortedDateArrayFromDateRangeConsumptionShares(
  dateRangeConsumptionShares: Array<DateRangeConsumptionShare>
) {
  const sortedDateRangeConsumptionShares = dateRangeConsumptionShares.sort(
    (a, b) => {
      if (a.firstDate && b.firstDate) {
        return (
          backendDateOrDateTimeToLuxonDateTime(a.firstDate).toUnixInteger() -
          backendDateOrDateTimeToLuxonDateTime(b.firstDate).toUnixInteger()
        );
      }
      return 0;
    }
  );
  return sortedDateRangeConsumptionShares;
}

function putNewShareIntoDateRangeConsumptionShares(
  currentShares: Array<DateRangeConsumptionShare>,
  newShare: DateRangeConsumptionShare
) {
  if (!currentShares || !newShare) {
    return currentShares;
  }
}
